import React from "react"

export interface DialogProps  {
    id: string
    title: string,
    open: boolean,
    footer?: JSX.Element,
    onClose?: () => void,
    small?: boolean
    padlock?: boolean
    children?: React.ReactNode
}

export interface DialogState {
}


export class Dialog extends React.Component<DialogProps, DialogState> {
    constructor(props?: DialogProps, context?: any) {
        super(props, context);

        this.state = {
        };
    }

    handleClose(e: React.MouseEvent<HTMLButtonElement> | React.MouseEvent<HTMLDivElement>) {
        e.preventDefault();
        this.props.onClose();
    }

    handleKeyboard(e: React.KeyboardEvent<HTMLDivElement>) {
        let target = e.target as HTMLElement;
        if (e.keyCode == 27) {
            this.props.onClose();
        }
    }


    componentDidUpdate(prevProps: DialogProps) {
        if (prevProps && prevProps.open != this.props.open) {
            $(() => {
                if (this.props.open) {
                    $('body').addClass('modal-open');
                    $('<div/>', {
                        'class': 'modal-backdrop show'
                    }).appendTo('body');
                }
                else {
                    $('.modal-backdrop').first().remove();
                    if ($('.modal-backdrop').length == 0) {
                        $('body').removeClass('modal-open');
                    }
                }
            });
        }
    }

    componentWillUnmount() {
        if (this.props.open) {
            $('.modal-backdrop').first().remove();
            if ($('.modal-backdrop').length == 0) {
                $('body').removeClass('modal-open');
            }
        }
    }

    render() {

        let footer: JSX.Element;
        if (this.props.footer) {
            footer = <div className='modal-footer'>
                {this.props.footer}
            </div>
        }

        let closeButton: JSX.Element;
        if (this.props.onClose) {
            closeButton = <button type="button" className='close' aria-label="Close" onClick={e => this.handleClose(e)}>
                <span aria-hidden="true">&times; </span>
            </button>;
        }

        return <div className={`modal${this.props.open ? ' in': ''}`}
            tabIndex={-1}
            role="dialog"
            aria-labelledby={`${this.props.id}-label`}
            aria-hidden="true"
            style={{ display: (this.props.open ? 'block' : '') }}
            onClick={e => (e.currentTarget == e.target) && this.handleClose(e)}
            onKeyDown={e => this.handleKeyboard(e)}>
            <div className={`modal-dialog${this.props.small ? '' : ' modal-lg'}`} role="document">                
                <div className='modal-content form-hidden-preview'>
                    <div className='modal-header'>
                        <h4 className='modal-title' id={`${this.props.id}-label`}>{this.props.title}</h4>
                        {closeButton}
                    </div>
                    <div className='modal-body'>
                        {this.props.children}
                    </div>
                    {footer}
                </div>
            </div>
        </div>
    }
}